export default function Activities({ value, onChange }) {
  const activities = [
    { key: "training", label: "Trening", emoji: "🏋️" },
    { key: "learning", label: "Učenje", emoji: "📚" },
    { key: "social", label: "Socijalni život", emoji: "👥" }
  ];

  const handleToggle = (key) => {
    const current = value[key];
    if (current?.active) {
      // Deaktiviraj
      onChange({
        ...value,
        [key]: { active: false, duration: "" }
      });
    } else {
      // Aktiviraj
      onChange({
        ...value,
        [key]: { active: true, duration: current?.duration || "" }
      });
    }
  };

  const handleDurationChange = (key, duration) => {
    onChange({
      ...value,
      [key]: { ...value[key], duration }
    });
  };

  return (
    <div>
      <h3>🏃 Aktivnosti</h3>

      <div className="activities-list">
        {activities.map((activity) => {
          const isActive = value[activity.key]?.active;
          return (
            <div key={activity.key} className="activity-item">
              <label className="activity-toggle">
                <input
                  type="checkbox"
                  checked={isActive || false}
                  onChange={() => handleToggle(activity.key)}
                />
                <span>{activity.emoji} {activity.label}</span>
              </label>

              {isActive && (
                <div className="activity-details">
                  <label>
                    Trajanje:
                    <input
                      type="text"
                      value={value[activity.key]?.duration || ""}
                      onChange={(e) => handleDurationChange(activity.key, e.target.value)}
                      placeholder="npr. 1h 30min"
                    />
                  </label>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
